import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'

import type { ArticleSection } from './types'

/** Bind an article's image directory once; `caption` is required so no figure ships uncredited. */
export const articleFigure =
  (dir: string) =>
  (file: string, caption: readonly I18nDescriptor[]): ArticleSection => ({
    type: 'images',
    images: [{ src: `${dir}/${file}`, caption }],
  })
